import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} fill="none" {...props}>
        <Path
            fill={props.color || designSystem.colors.neutral900}
            d="M1.75 7.668V1.832A1 1 0 0 1 3.29.99L7.83 3.91a1 1 0 0 1 0 1.682L3.29 8.51a1 1 0 0 1-1.54-.842Z"
        />
    </Svg>
);
export default SvgComponent;
